<template>
  <div class="sticky-starter-nav" :class="componentClasses">
    <div class="sticky-starter-nav__content">
      <div class="sticky-starter-nav__main-content" :class="mainContentClasses">
        <div
          class="sticky-starter-nav__share-button-container"
          v-if="isSocialShareEnabled"
        >
          <button
            @click="shareButtonClicked()"
            class="sticky-starter-nav__share-button"
          >
            Share
          </button>
        </div>
        <slot></slot>
      </div>
      <div
        class="sticky-starter-nav__social-content"
        v-if="isSocialShareEnabled"
      >
        <button
          @click="backButtonClicked()"
          class="sticky-starter-nav__back-button"
        >
          <svg width="10" height="16" xmlns="http://www.w3.org/2000/svg">
            <path
              stroke-width="2.4"
              d="M8 2L2 8.164627 8 14"
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <a
          :href="socialLink.url"
          v-for="socialLink in socialShareModel.social_links"
          :key="socialLink.key"
          @click.prevent="socialLinkClicked(socialLink)"
          class="sticky-starter-nav__social-link"
          v-html="socialLink.icon"
        ></a>
        <!-- Empty div is because there are an odd number of social icons, and design wants the middle icon to be centered -->
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { initStickyStarterNav } from '../../../helpers/sticky-starter-nav';
import { blogSocialShare } from '../../../../pages/helpers/sk-blog-social-share';

export default {
  props: {
    socialShareIcons: {
      type: String
    }
  },
  components: {},
  created() {
    if (this.socialShareIcons) {
      this.socialShareModel = JSON.parse(this.socialShareIcons)[0];
      this.isSocialShareEnabled = true;
    }
  },
  mounted() {
    initStickyStarterNav();
  },
  data() {
    return {
      isSocialShareEnabled: false,
      socialShareModel: null,
      shouldShowSocialIcons: false
    };
  },
  computed: {
    componentClasses() {
      return {
        'social-share-active': this.shouldShowSocialIcons,
        'social-share-enabled': this.isSocialShareEnabled
      };
    },
    mainContentClasses() {
      return {
        'social-share-enabled': this.isSocialShareEnabled
      };
    }
  },
  methods: {
    shareButtonClicked() {
      this.shouldShowSocialIcons = true;
    },
    backButtonClicked() {
      this.shouldShowSocialIcons = false;
    },
    socialLinkClicked(socialLink) {
      blogSocialShare(socialLink.key, socialLink.url);
      if (socialLink.popup_title) {
        window.open(
          socialLink.url,
          socialLink.popup_title,
          this.socialShareModel.popup_window_dimensions
        );
      } else {
        window.open(socialLink.url, '_blank');
      }
    }
  }
};
</script>
